import { Injectable } from '@angular/core'
import { select, Store } from '@ngrx/store'
import * as Reducers from '../../store/reducers'
import * as SettingsActions from '../../store/settings/actions'
import { BehaviorSubject, Observable } from 'rxjs';
import { MessplatzService } from '@app/services/messplatz/messplatz.service';
import { Messgeraete } from '@interfaces/interfaces';
import { Router } from '@angular/router';

@Injectable({
	providedIn: 'root'
})
export class ProtectedPrivacyService {
	private _isProtected = false
	private _status$: BehaviorSubject<boolean> = new BehaviorSubject(false)

	constructor(
		private messplatzService: MessplatzService,
		private store: Store<never>,
		private router: Router,
	) {
		if (messplatzService.hasAvailableDevice(Messgeraete.TouchScreen)) {
			this.enable();
		}
		store.pipe(select(Reducers.getSettings)).subscribe(state => {
			this._isProtected = state.is_privacy_protected
			this._status$.next(this._isProtected)
		})
	}

	public enable(): boolean {
		this.store.dispatch(new SettingsActions.SetStateAction({
			is_privacy_protected: true
		}))

		if (this.router.url.startsWith('/project') || this.router.url.startsWith('/users')) {
			this.router
				.navigate([''], { queryParams: { returnUrl: this.router.url } })
				.catch(console.error);
		}

		return true;
	}

	public disable(): boolean {
		if (!this._isProtected)
			return false;

		this.store.dispatch(new SettingsActions.SetStateAction({
			is_privacy_protected: false
		}))

		return true;
	}

	get statusProtected(): boolean {
		return this._isProtected
	}

	toggleStatus(): void {
		if (this._isProtected)
			this.disable()
		else
			this.enable()
	}

	toggleChange$(): Observable<boolean> {
		return this._status$
	}
}
